/* NEWLUNA 3.0 spotlight hotspots: one open at a time, Escape or an outside
   click closes it, and the numbered legend below the photo mirrors the dots. */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.spotReady) return;
    root.dataset.spotReady = '1';
    var spots = Array.prototype.slice.call(root.querySelectorAll('[data-hs]'));
    if (!spots.length) return;
    function close(except) {
      spots.forEach(function (s) {
        if (s === except) return;
        var b = s.querySelector('[data-hs-btn]'), p = s.querySelector('[data-hs-pop]');
        s.classList.remove('is-open');
        if (b) b.setAttribute('aria-expanded', 'false');
        if (p) p.hidden = true;
      });
    }
    spots.forEach(function (s) {
      var b = s.querySelector('[data-hs-btn]'), p = s.querySelector('[data-hs-pop]');
      if (!b || !p) return;
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = !s.classList.contains('is-open');
        close(s);
        s.classList.toggle('is-open', open);
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        p.hidden = !open;
      });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest || !e.target.closest('[data-hs]')) close(); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var open = root.querySelector('.hs.is-open [data-hs-btn]');
        close();
        if (open) open.focus();
      }
    });
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-spot]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
